<template>
    <div class="d-flex flex-column align-items-center my-5">
        <be-alert border icon-background color="success" icon="check" style="max-width:600px" v-if="isCoach">
            <strong>Digital.Check erfolgreich abgeschlossen</strong>
            <p>Bitte führe nun das Assessment durch.</p>
            <router-link :to="{ name: 'assessment', params: { id: this.assessment.id } }" class="btn btn-primary">Assessment anzeigen</router-link>
        </be-alert>

        <be-alert border icon-background color="success" icon="check" style="max-width:600px" v-else>
            <strong>Digital.Check erfolgreich abgeschlossen</strong>
            <p v-if="coach">Sie werden von {{coach.firstname}} {{coach.lastname}} entsprechend kontaktiert um das Assessment durchzuführen und die Resultate zu besprechen.</p>
        </be-alert>

        <be-card border featured header-contrast title="Ihr Coach"  style="max-width:600px" v-if="!isCoach">
            <df-coach :data="coach"/>
        </be-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Assessment from '../../../models/Assessment';

    export default {
        props: {
            assessment: Assessment,
        },

        computed: {
            ...mapGetters('user', ['user', 'isCoach']),
        },

        asyncComputed: {
            async coach() {
                return (await this.assessment.getCustomer()).getCoach();
            },
        },
    };
</script>
